export const PAYMENT_REQUEST_ROUTING = [
    {
        path: '/payment-request',
        name: 'payment-request',
        meta: {
            auth: true,
            breadcrumb: [
                { name: 'Yêu cầu giao hàng', pathName: 'payment-request', icon: 'fa fa-envelope' },
            ]
        },
        component: () => import('./PaymentRequest.vue'),
        redirect: { name: 'payment-request-index' },
        children: [
            { 
                path: '/yeu-cau-giao-hang.html',
                name: 'payment-request-index',
                component: () => import('./components/main-payment-request/MainPaymentRequest.vue')
            },
            {
                path: '/yeu-cau-giao-hang/buoc-1.html',
                name: 'payment-request-new',
                meta: {
                    breadcrumb: [
                        { name: 'Tạo mới yêu cầu giao hàng', pathName: 'yeu-cau-giao-hang1', icon: 'fa fa-bar-chart' },
                ] },
                component: () => import('./components/add-new-payment-request-step1/AddNewPaymentRequest.vue'),
            },
            {
                path: '/payment-request/buoc-2.html',
                name: 'yeu-cau-giao-hang2',
                meta: {
                    breadcrumb: [
                        { name: 'Thông tin vận chuyển', pathName: 'yeu-cau-giao-hang2', icon: 'fa fa-bar-chart' },
                ] },
                component: () => import('./components/add-new-payment-request-step2/AddNewPaymentRequest.vue'),
            },
            {
                path: '/yeu-cau-giao-hang/:id',
                name: 'payment-request-detail',
                meta: {
                    breadcrumb: [
                        { name: 'Chi tiết yêu cầu giao hàng', pathName: 'payment-request-detail', icon: 'fa fa-bar-chart' },
                ] },
                component: () => import('./components/detail-payment-request/DetailPaymentRequest.vue'),
            }
        ]
    }
];